export default "__VITE_ASSET__TG7CAjhp__"